import EmailMgr from '@app/custom-api/email-custom-api'

// Constants
import {API_ERROR_MESSAGE} from '@app/constants'

// Hooks
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useIntl} from 'react-intl'
import {useToast} from '@app/hooks/use-toast'
import useMultiSite from '@app/hooks/use-multi-site'

// Utils
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/**
 * Utility hook for sending emails via the custom API.
 */
export const useSendEmail = () => {
    const {app: appConfig} = getConfig()
    const {getTokenWhenReady} = useAccessToken()
    const {site, locale} = useMultiSite()
    const intl = useIntl()
    const toast = useToast()

    const emailApi = new EmailMgr({
        parameters: {
            siteId: site.id,
            organizationId: appConfig.commerceAPI.parameters.organizationId,
            locale: locale.id
        }
    })

    const sendEmail = async (mailObj) => {
        let result = {
            success: false,
            message: ''
        }

        try {
            const token = await getTokenWhenReady()
            const emailResult = await emailApi.sendEmail(mailObj, token)

            result.success = emailResult.success
            result.message = emailResult.message
        } catch (error) {
            toast({
                title: intl.formatMessage(API_ERROR_MESSAGE),
                description: '',
                status: 'error'
            })

            result.message = error.message
            result.success = false
        }

        return result
    }

    return {sendEmail}
}
